
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/carrier",
      function () {
        return require("private-next-pages/carrier/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/carrier"])
      });
    }
  